import { env } from '@ria-client/env';
import { Info } from 'lucide-react';

export interface MissingNodeProps {
  type: string;
}

// Mirrors MUI <Alert severity="info" variant="outlined"> from @ria-client/ui MissingComponent.
export function MissingNode({ type }: MissingNodeProps) {
  if (env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod') {
    return null;
  }

  return (
    <div
      role="alert"
      className="my-2 flex rounded-[4px] border border-(--content-yellow-lightest) px-4 py-1.5 text-sm text-[#66625d]"
    >
      <div className="mr-3 flex py-[7px] text-(--content-yellow-light) opacity-90">
        <Info aria-hidden className="size-[22px]" />
      </div>
      <div className="py-2">
        <div className="-mt-0.5 mb-[5.6px] text-base leading-6 font-medium">
          Structured Content Renderer missing component for type <strong>{type}</strong>
        </div>
        <span className="mt-1 block text-[13px] leading-[1.4] text-muted-foreground">
          This warning is only visible in non-production environments.
        </span>
      </div>
    </div>
  );
}
